
import { buildScriptTag } from "../script-utils";
import { ScriptProps } from "../script-types";

/**
 * Generates a debug tracking script with extra debug flags
 */
export function getDebugTrackingScript({ pixelId, scriptMetadata }: ScriptProps): string {
  const scriptTag = buildScriptTag({
    pixelId,
    scriptMetadata,
    debug: true,
  });
  
  return scriptTag;
}
